import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryCreditCardAccount } from '../../models'

export interface IUseCreditCardStatementDetailsPresenterParams {
  accountId: number
}

/**
 * Shared route-context data source (Sibling Pages pattern): besides this
 * feature's own Presenter, the CreditCardAccountDetailsView lock guard and
 * the ReconciliationMatchView / CreateCreditCardBillView Feature Sets consume
 * this hook data-only (no View rendered). React Query dedupes the calls via
 * the shared `creditCardAccountQueries.detail` config.
 */
export const useCreditCardStatementDetailsPresenter = ({
  accountId,
}: IUseCreditCardStatementDetailsPresenterParams) => {
  const intl = useProcurifyIntl()

  const { account, isLoading } = useQueryCreditCardAccount({
    accountId,
    onError: (err) => {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    },
  })

  return {
    account,
    session: account?.session ?? null,
    isLoading,
  }
}
